import { AIProvider, ProviderConfig, ProviderType, ProviderModel, GenerateRequest, GenerateResponse } from './types';
import { tauriFetch, tauriStreamFetch, isTauri } from '../tauriFetch';

export abstract class BaseProvider implements AIProvider {
  abstract readonly type: ProviderType;
  abstract readonly name: string;
  abstract readonly supportsStreaming: boolean;
  abstract readonly supportsFunctionCalling: boolean;
  abstract readonly requiresApiKey: boolean;

  protected config: ProviderConfig | null = null;

  configure(config: ProviderConfig): void {
    this.config = config;
  }

  isConfigured(): boolean {
    if (!this.config || !this.config.enabled) return false;
    if (this.requiresApiKey && !this.config.apiKey) return false;
    return true;
  }

  abstract testConnection(): Promise<{ success: boolean; message: string; models?: ProviderModel[] }>;
  abstract listModels(): Promise<ProviderModel[]>;
  abstract generate(request: GenerateRequest): Promise<GenerateResponse>;

  protected formatError(error: any): string {
    if (error?.message) return error.message;
    if (typeof error === 'string') return error;
    return 'Unknown error occurred';
  }

  protected async fetchWithTimeout(url: string, options: RequestInit, timeoutMs: number = 30000): Promise<Response> {
    const headers: Record<string, string> = {};
    if (options.headers) {
      if (options.headers instanceof Headers) {
        options.headers.forEach((value, key) => {
          headers[key] = value;
        });
      } else if (Array.isArray(options.headers)) {
        options.headers.forEach(([key, value]) => {
          headers[key] = value;
        });
      } else {
        Object.assign(headers, options.headers);
      }
    }
    
    return tauriFetch(url, {
      method: options.method as string,
      headers,
      body: options.body as string | undefined,
      timeout: timeoutMs
    });
  }

  protected async streamFetch(url: string, options: RequestInit): Promise<Response> {
    const headers: Record<string, string> = {};
    if (options.headers) {
      if (options.headers instanceof Headers) {
        options.headers.forEach((value, key) => {
          headers[key] = value;
        });
      } else if (Array.isArray(options.headers)) {
        options.headers.forEach(([key, value]) => {
          headers[key] = value;
        });
      } else {
        Object.assign(headers, options.headers);
      }
    }
    
    return tauriStreamFetch(url, {
      method: options.method as string,
      headers,
      body: options.body as string | undefined
    });
  }

  protected isTauriEnvironment(): boolean {
    return isTauri();
  }
}
